import React, { type HTMLAttributes } from 'react';
import cx from 'classnames';
import { mcdsFlagCheck } from '@mc/wink/helpers/utils-ts';
import stylesheet from './Menu.css';

export type MenuProps = {
  /** Consumes `MenuItem` components */
  children?: React.ReactNode;
  /** Current state on whether Menu is expanded or collapsed */
  isExpanded?: boolean;
  /** Function that updates isExpanded value */
  setIsExpanded?: (expanded: boolean) => void;
  /** Determines whether the menu has a max-height*/
  fullHeight?: boolean;
  /** Determines the size of the menu */
  size?: 'small' | 'medium';
} & HTMLAttributes<HTMLDivElement>;

const Menu = React.forwardRef<HTMLDivElement, MenuProps>(function Menu(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  { children, setIsExpanded = () => {}, fullHeight, size = 'small', ...props },
  menuRef,
) {
  const isReleased = mcdsFlagCheck(
    'xp_mcds_redesign_components_organisms_part_2',
  );

  return (
    isReleased && (
      <div
        className={cx(
          stylesheet.menu,
          fullHeight && stylesheet.fullHeight,
          size && stylesheet[size],
        )}
        ref={menuRef}
        {...props}
      >
        {children}
      </div>
    )
  );
});

export { Menu as default };
